module.exports = "<div id=\"news\">\r\n  <tmb-spinner></tmb-spinner>\r\n  <app-news-memo></app-news-memo>\r\n  <div id=\"next_btn\">\r\n    <button md-button md-raised-button color=\"primary\" (click)=\"navigateWaitingRoom()\" class=\"fa fa-pull-right\">Next</button>\r\n  </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/news/news.component.html
// module id = ../../../../../src/app/pages/news/news.component.html
// module chunks = main